/**
 * Review Drawer Controller — Superdesk yorumlarını yandan açılan drawer'da gösterir.
 * Tetikleyici: Superdesk "Star Rating Summary" app block'u (superdesk-star-rating-summary)
 * veya [data-open-review-drawer].
 */
(() => {
  const WIDGET = 'superdesk-product-reviews-widget';
  const TRIGGER = '[data-open-review-drawer], superdesk-star-rating-summary';
  let lastTrigger = null;

  const getDrawer = () => document.getElementById('ReviewDrawer');
  const getBackdrop = () => document.getElementById('ReviewDrawerBackdrop');

  // Widget snippet'teki inline script ile taşınamadıysa (ör. app block "Uygulamalar" bölümünde) buraya al.
  const adoptWidget = () => {
    const drawer = getDrawer();
    const body = drawer && drawer.querySelector('[data-review-drawer-body]');
    const widget = document.querySelector(WIDGET);
    if (!body || !widget || body.contains(widget)) return;

    const block = widget.closest('.shopify-app-block');
    if (window.customElements && window.customElements.get(WIDGET)) {
      // Upgrade edilmiş elementi taşımak connectedCallback'i ikinci kez tetikler; taze kopya kur.
      body.appendChild(widget.cloneNode(false));
      widget.remove();
    } else {
      body.appendChild(block || widget);
    }
  };

  const open = (trigger) => {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer || !backdrop) return;
    adoptWidget();
    lastTrigger = trigger || null;
    drawer.classList.add('is-active');
    backdrop.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.focus({ preventScroll: true });
  };

  const close = () => {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer || !drawer.classList.contains('is-active')) return;
    drawer.classList.remove('is-active');
    if (backdrop) backdrop.classList.remove('is-active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER);
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }
    if (event.target.closest('[data-review-drawer-close]')) {
      close();
      return;
    }
    if (event.target.closest('[data-review-write]')) {
      const widget = document.querySelector(`#ReviewDrawer ${WIDGET}`);
      if (widget && typeof widget.onWriteAReview === 'function') widget.onWriteAReview();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      // Superdesk'in yorum formu/medya modalı açıksa önce o kapansın.
      if (document.getElementById('sdesk-embedded-review-form-modal')) return;
      close();
      return;
    }
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest && event.target.closest(TRIGGER);
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  document.addEventListener('DOMContentLoaded', adoptWidget);
  document.addEventListener('shopify:section:load', () => {
    document.body.style.overflow = '';
    adoptWidget();
  });
})();
